<template>
  <section-card class="text-accent">
    <div>
      Em uma escala de 0 a 10, quanto você recomendaria a
      <span class="text-bold">Docstage</span> para um amigo
      ou familiar?
    </div>
    <div class="q-my-md">
      <nps-response-buttons v-model="modelVal.score" required />
    </div>
    <div>
      Por favor, nos ajude a entender a razão por trás da sua
      pontuação deixando um comentário.
    </div>
    <div class="row">
      <div class="col-12">
        <q-input
          v-model="modelVal.comment"
          placeholder="Comente aqui"
          autogrow
        />
      </div>
    </div>
  </section-card>
</template>

<script>
import { computed, defineComponent } from 'vue'
import NpsResponseButtons from 'src/components/nps/NpsResponseButtons.vue'

export default defineComponent({
  name: 'NpsResponseContent'
})

</script>

<script setup>

const props = defineProps({
  modelValue: {
    type: Object,
    required: false
  }
})

const emit = defineEmits(
  ['update:modelValue']
)

const modelVal = computed({
  get: () => props.modelValue,
  set: (newValue) => {
    emit('update:modelValue', newValue)
  }
})

</script>
